<meta
  http-equiv="Cache-Control"
  content="no-cache, no-store, must-revalidate"
/>
<meta http-equiv="Pragma" content="no-cache" />
<meta http-equiv="Expires" content="0" />
<div class="stretch flex center align" *ngIf="loadingComplete; else loading">
  <mat-card class="blueSweepCard">
    <div class="stretch flex center">
      <img class="moyaLogo" src="/assets/moya_logo.svg" />
    </div>
    <mat-card-header>
      <div class="header">
        <mat-card-title>
          <div>Select or create a workspace</div>
        </mat-card-title>

        <mat-card-subtitle>
          <p class="header-description">
            A workspace is a dedicated place to access a specific organisation
            or team’s MoyaApp services.
          </p>
        </mat-card-subtitle>
      </div>
    </mat-card-header>

    <!-- User Workspaces -->
    <div>
      <!--  -->
      <div class="search-container" *ngIf="businessOrganizations.length > 6">
        <mat-form-field class="search-input" appearance="outline">
          <input
            matInput
            placeholder="Search for workspace"
            [(ngModel)]="searchValue"
            [disabled]="cardsDisabled"
            (ngModelChange)="searchWorkspaces()"
          />
          <img matSuffix class="search-icon" src="/assets/search_icon.svg" />
        </mat-form-field>
      </div>
      <div *ngIf="businessOrganizations.length" class="organisation-list">
        <ng-container *ngIf="!searchValue.length">
          <ng-container *ngFor="let item of businessOrganizations">
            <app-small-card-button
              [disabled]="cardsDisabled || item.revoked"
              (click)="signInOrganization(item.id, item.revoked)"
              class="clickable"
            >
              <div image class="flex align center">
                <app-account-photo
                  [disabled]="cardsDisabled || item.revoked"
                  [name]="item.name.trim()"
                ></app-account-photo>
              </div>
              <div
                title
                class="item-name"
                style="font-size: large; min-width: 250px"
              >
                {{ item.name | ellipsis : 25 }}
              </div>
              <div *ngIf="item.revoked" subTitle class="revokedWorkspace">
               <p class="revoked-text">
                Workspace Disabled
               </p>
                  <div class="icon">
                    <img class="clickable" (click)="openDisabledDialog()" icon src="/assets/help_icon.svg" />
                  </div>
              </div>
            </app-small-card-button>
          </ng-container>
        </ng-container>
        <ng-container *ngIf="searchValue.length">
          <ng-container *ngIf="searchedOrganizations.length">
            <ng-container *ngFor="let item of searchedOrganizations">
              <app-small-card-button
                [disabled]="cardsDisabled || item.revoked"
                (click)="signInOrganization(item.id, item.revoked)"
                class="clickable"
              >
                <div image class="flex align center">
                  <app-account-photo
                    [disabled]="cardsDisabled || item.revoked"
                    [name]="item.name.trim()"
                  ></app-account-photo>
                </div>
                <div
                  title
                  class="item-name"
                  style="font-size: large; min-width: 250px"
                >
                  {{ item.name | ellipsis : 25 }}
                </div>
                <div *ngIf="item.revoked" subTitle class="revokedWorkspace">
                  Workspace Disabled
                </div>
              </app-small-card-button>
            </ng-container>
          </ng-container>
          <ng-container *ngIf="searchedOrganizations.length == 0">
            <div class="not-found">
              <div>Workspace not found</div>
            </div>
          </ng-container>
        </ng-container>
      </div>
      <div *ngIf="!businessOrganizations.length" class="no-organisations">
        <div>You can create as many workspaces as you need.</div>
      </div>
    </div>

    <!-- Pending Invitations -->
    <div class="invitations-container" *ngIf="pendingInvitations.length">
      <div class="header-container">
        <div class="section-header">Pending invites</div>
        <hr class="hr" style="width: 100%" />
      </div>
      <ng-container *ngFor="let item of pendingInvitations">
        <app-small-card-button
          (click)="viewPendingInvitation(item)"
          [disabled]="cardsDisabled"
          class="clickable"
        >
          <div image class="flex align center">
            <app-account-photo
              [disabled]="cardsDisabled"
              [name]="item.organization.name.trim()"
            ></app-account-photo>
          </div>
          <div
            title
            class="item-name"
            style="font-size: large; min-width: 250px"
          >
            {{ item.organization.name.trim() | ellipsis : 25 }}
          </div>
        </app-small-card-button>
      </ng-container>
    </div>

    <div class="bottom-container">
      <app-create-workspace
        [allUserOrganizations]="allUserOrganizations"
        [maxLength]="50"
        (formDisplayed)="disableCards($event)"
        (workspaceName)="CreateOrganisation($event)"
        *ngIf="!creatingOrg"
      >
        <div class="create-title" title>Create workspace</div>
      </app-create-workspace>
      <div class="createOrg-loader" *ngIf="creatingOrg">
        <mat-spinner [diameter]="40"></mat-spinner>
      </div>

      <div style="height: 30px"></div>

      <p class="logout-container">
        <u class="clickable logout" (click)="logout()">Logout</u>
      </p>
    </div>
  </mat-card>
</div>
<ng-template #loading>
  <div class="loader">
    <mat-spinner></mat-spinner>
  </div>
</ng-template>
